/**
 * Validation constants - single source of truth.
 *
 * These values match the backend defaults in responsum/validation/schemas.py
 * The types are auto-generated, but the default values need to be specified here.
 */

import type { ValidationConstants } from "../../types/validation.generated";

/**
 * Default validation constants matching backend.
 * Use this as the authoritative source of validation rules.
 */
export const VALIDATION: Required<ValidationConstants> = {
  display_name: {
    min_length: 1,
    max_length: 50,
    dangerous_chars: ["<", ">", '"', "'", "\\", "\x00"],
  },
  password: {
    min_length: 8,
    require_uppercase: true,
    require_lowercase: true,
    require_digit: true,
  },
  session_id: {
    min_length: 3,
    max_length: 50,
  },
};
